"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var TimeoutScheduler_1 = require("../scheduler/TimeoutScheduler");
var DefaultReconnectController = /*#__PURE__*/function () {
  function DefaultReconnectController(reconnectTimeoutMs, backoffPolicy) {
    _classCallCheck(this, DefaultReconnectController);
    this.reconnectTimeoutMs = reconnectTimeoutMs;
    this.backoffPolicy = backoffPolicy;
    this.shouldReconnect = true;
    this.onlyRestartPeerConnection = false;
    this.firstConnectionAttempted = false;
    this.firstConnectionAttemptTimestampMs = 0;
    this.lastActiveTimestampMs = Infinity;
    this._isFirstConnection = true;
    this.backoffTimer = null;
    this.backoffCancel = null;
    this.reset();
  }
  _createClass(DefaultReconnectController, [{
    key: "timeSpentReconnectingMs",
    value: function timeSpentReconnectingMs() {
      if (!this.firstConnectionAttempted) {
        return 0;
      }
      return Date.now() - this.firstConnectionAttemptTimestampMs;
    }
  }, {
    key: "hasPastReconnectDeadline",
    value: function hasPastReconnectDeadline() {
      if (Date.now() - this.lastActiveTimestampMs >= this.reconnectTimeoutMs) {
        return true;
      }
      return this.timeSpentReconnectingMs() >= this.reconnectTimeoutMs;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.cancel();
      this.shouldReconnect = true;
      this.onlyRestartPeerConnection = false;
      this.firstConnectionAttempted = false;
      this.firstConnectionAttemptTimestampMs = 0;
      this.lastActiveTimestampMs = Infinity;
      this.backoffPolicy.reset();
    }
  }, {
    key: "startedConnectionAttempt",
    value: function startedConnectionAttempt(isFirstConnection) {
      this._isFirstConnection = isFirstConnection;
      if (!this.firstConnectionAttempted) {
        this.firstConnectionAttempted = true;
        this.firstConnectionAttemptTimestampMs = Date.now();
      }
    }
  }, {
    key: "hasStartedConnectionAttempt",
    value: function hasStartedConnectionAttempt() {
      return this.firstConnectionAttempted;
    }
  }, {
    key: "isFirstConnection",
    value: function isFirstConnection() {
      return this._isFirstConnection;
    }
  }, {
    key: "disableReconnect",
    value: function disableReconnect() {
      this.shouldReconnect = false;
    }
  }, {
    key: "enableRestartPeerConnection",
    value: function enableRestartPeerConnection() {
      this.onlyRestartPeerConnection = true;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.disableReconnect();
      if (this.backoffTimer) {
        this.backoffTimer.stop();
        if (this.backoffCancel) {
          this.backoffCancel();
          this.backoffCancel = null;
        }
      }
    }
  }, {
    key: "retryWithBackoff",
    value: function retryWithBackoff(retryFunc, cancelFunc) {
      var _this = this;
      var willRetry = this.shouldReconnect && !this.hasPastReconnectDeadline();
      if (willRetry) {
        this.backoffCancel = cancelFunc;
        this.backoffTimer = new TimeoutScheduler_1.default(this.backoffPolicy.nextBackoffAmountMs());
        this.backoffTimer.start(function () {
          _this.backoffCancel = null;
          retryFunc();
        });
      }
      return willRetry;
    }
  }, {
    key: "shouldOnlyRestartPeerConnection",
    value: function shouldOnlyRestartPeerConnection() {
      return this.onlyRestartPeerConnection;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new DefaultReconnectController(this.reconnectTimeoutMs, this.backoffPolicy);
    }
  }, {
    key: "setLastActiveTimestampMs",
    value: function setLastActiveTimestampMs(timestampMs) {
      this.lastActiveTimestampMs = timestampMs;
    }
  }]);
  return DefaultReconnectController;
}();
exports.default = DefaultReconnectController;